export default __webpack_public_path__ + "static/media/godaddy.f20feeb3.png";